export const NO_VALUE = '–'
export const MULTIPLICATION = '×'
export const HASH_SYMBOL = '#'
export const NO_SPECIFIED = 'Unspecified'
export const NOT_PROVIDED = 'Not provided'
export const EMPTY_DATE_VALUE = '(-)'
export const EMPTY_STRING = ''
export const BULLET = '•'
export const PERIOD = '.'
export const COLON = ':'
export const DASH = '-'
export const EMPTY_CLASS_NAME = ''
export const HIGHLIGHTED_EVENT_CLASS_NAME = 'highlighted-event'
export const INTERPUNCT = '·'
export const NONE_COUNT_LABEL = 'None'
export const NEW_DELIVERY_PATH_KEYWORD = 'new'
export const LOCATION_SEPARATOR = '|'
export const QR_CODE_LOGO_SRC =
  '/static/icons/strux-hub-dark-with-background.svg'
export const FORMS_REPORT_TEMPLATE_ID = 'forms_list_report_api'
export const MATERIALS_REPORT_TEMPLATE_ID = 'materials_list_report_api'
export const DELIVERIES_REPORT_TEMPLATE_ID = 'deliveries_list_report_api'
export const undergroundLevelBaseName = 'UG'
export const NO_IMAGE_PATH = '/static/images/no-image.png'
export const MEGABYTE = 'MB'
export const SLASH = '/'
